export default function CircleCheckbox({ isChecked, onClick }) {
    const handleCheckboxClick = (e) => {
      e.stopPropagation();
      onClick();
    };
  
    return (
      <label className="circle-checkbox checkbox-overlay">
        <input
          type="checkbox"
          className="circle"
          checked={isChecked}
          onChange={handleCheckboxClick}
        />
      </label>
    );
  }
  